import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = ["source", "checkbox", "modal", "form"];

    finishEditting() {
        this.toggle();
        this.uncheckAllCheckboxes();
    }

    editMode() {
        this.toggle();
    }

    toggle() {
        for(let target of this.sourceTargets) {
            target.classList.toggle('hidden');
        }
    }

    deleteSelected() {
        if (this.selectedItems().length > 0) {
            this.modalTarget.classList.remove("hidden");
        } else {
            alert("Select at least one item to delete");
        }
    }

    cancelDelete() {
        this.modalTarget.classList.add("hidden");
    }

    confirmDelete() {
        const selectedIds = this.selectedItems();

        selectedIds.forEach(id => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "item_ids[]";
            input.value = id;
            this.formTarget.appendChild(input);
        });

        this.formTarget.submit();
    }

    selectedItems() {
        return this.checkboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
    }

    uncheckAllCheckboxes() {
        this.checkboxTargets.forEach((i) => {
            if (!i.disabled) {
                i.checked = false;
            }
        });
    }
}
